import { ContextType } from "@/services/bedrock/dtos/DesignPackage";

const ALL: ContextType[] = ["review", "player", "none"];

export const LOADING_TIPS: { text: string; appliesTo: ContextType[] }[] = [
  { text: "Refine one slide at a time, or all of them at once.", appliesTo: ALL },
  { text: `Try "overlap the player's headshot on the quote card" as your first refinement.`, appliesTo: ALL },
  { text: "Switch themes in the preview to see the design in each branch's colors and logo.", appliesTo: ALL },
  { text: "Carousels can end with a call-to-action slide that shows the player's profile.", appliesTo: ALL },
  {
    text: "Publishing adds this design to your prompt library. Players see it with their own name and branding.",
    appliesTo: ALL,
  },
  { text: `Say "highlight the best phrase" to make the review quote pop.`, appliesTo: ["review"] },
  { text: "Every post is built from the exact design you approve. Nothing is redrawn.", appliesTo: ALL },
];
